'use strict'

class ItemPlannerOverviewCtrl {

    constructor (
        $scope,
        $rootScope,
        $state,
        $http,
        $timeout,
        $mdDialog,
        $mdToast,
        filterMap,
        $location,
        selection,
        wsEvents,
    ) {

        this.onWindowKeyDown = this.onWindowKeyDown.bind(this)
        this.onItemSaved = this.onItemSaved.bind(this)
        this.destroy = this.destroy.bind(this)

        // Dependencies
        this.$scope = $scope
        this.$rootScope = $rootScope
        this.$state = $state
        this.$http = $http
        this.$timeout = $timeout
        this.$mdDialog = $mdDialog
        this.$mdToast = $mdToast
        this.$location = $location
        this.selection = selection

        //Controller vars
        this.date = new Date($location.search().date)
        if (isNaN(this.date.getTime())) {
            this.date = new Date()
        }

        this.currentTimeOut = null
        this.allowedToPaste = true
        this.days = {}
        this.campaigns = []
        this.loaded = false
        this.filterMap = filterMap
        this.filterCount = 0

        $rootScope.selectedCampaign = null

        $http.get('/modeltypes_options/campaign')
            .then((response) => {
                this.campaign_options = response.data
                // Fetch the overview items
                this.fetch(this.date)
            })

        $scope.$on('$destroy', this.destroy)
        $scope.$on('item-planner_item_saved', this.onItemSaved)
        window.addEventListener('keydown', this.onWindowKeyDown)

        const {
            station_namespace,
        } = window.CONFIG

        const wsBroadcastCreatedEvents = wsEvents(`campaignItem.created.${station_namespace}`)
        wsBroadcastCreatedEvents.messageCallback(this.onCampaignItemCreatedEvent.bind(this))

        const wsBroadcastUpdatedEvents = wsEvents(`campaignItem.updated.${station_namespace}`)
        wsBroadcastUpdatedEvents.messageCallback(this.onCampaignItemUpdatedEvent.bind(this))

        const wsBroadcastDeletedEvents = wsEvents(`campaignItem.deleted.${station_namespace}`)
        wsBroadcastDeletedEvents.messageCallback(this.onCampaignItemDeletedEvent.bind(this))

        $scope.$on('$destroy', () => {
            wsBroadcastCreatedEvents.destroy()
            wsBroadcastUpdatedEvents.destroy()
            wsBroadcastDeletedEvents.destroy()
        })

        this.debounceCountCampaignItemsInWeek = _.debounce(() => {
            this.countCampaignItemsInWeek()
        }, 50)
    }

    onCampaignItemCreatedEvent (data) {
        this.$scope.$applyAsync(() => {
            // console.log('itemCreatedEvent', data.item.id, data.item);

            const campaignId = parseInt(data.item.campaign_id)
            this.updateCampaignCounter(campaignId, 1)

            this.itemSaved(false, data.item)
        })
    }

    onCampaignItemUpdatedEvent (data) {
        const campaignId = parseInt(_.get(data, 'item.campaign_id', 0))
        const oldCampaignId = parseInt(_.get(data, 'oldItem.campaign_id', 0))
        if (oldCampaignId !== campaignId) {
            this.updateCampaignCounter(campaignId, 1)
            this.updateCampaignCounter(oldCampaignId, -1)
        }

        const blockId = parseInt(_.get(data, 'item.block_id', 0))
        const oldBlockId = parseInt(_.get(data, 'oldItem.block_id', 0))
        const blockChanged = oldBlockId !== blockId
        if (blockChanged) {
            this.$rootScope.$broadcast('item-planner_remove-item_block_' + oldBlockId, data.oldItem)
        }

        this.itemSaved(!blockChanged, data.item)
    }

    onCampaignItemDeletedEvent (data) {
        this.$scope.$applyAsync(() => {
            // console.log('itemDeletedEvent', data.item.id, data.item);

            const blockId = parseInt(data.item.block_id)
            const campaignId = parseInt(data.item.campaign_id)
            this.updateCampaignCounter(campaignId, -1)

            this.$rootScope.$broadcast('item-planner_remove-item_block_' + blockId, data.item)
        })
    }

    previousWeek () {
        this.fetch(new Date(this.date.setDate(this.date.getDate() - 7)))
    }

    currentDay () {
        this.fetch(new Date())
    }

    nextWeek () {
        this.fetch(new Date(this.date.setDate(this.date.getDate() + 7)))
    }

    pickDate () {
        this.fetch(new Date(this.date.setDate(this.date.getDate())))
    }

    fetch (date, onlyReloadItem = false) {
        let modelTypeIds = []

        this.filterMap.map((filter) => {
            if (filter.enabled) {
                modelTypeIds.push(filter.id)
            }
        })

        this.selection.clearSelection()
        this.$location.search('date', moment(date).format('YYYY-MM-DD'))

        this.date = date
        const dateString = date.toISOString().split('T')[0]
        if (!onlyReloadItem) this.loaded = false
        this.$http.get(`/item-planner/overview/${dateString}?modelTypeIds=${modelTypeIds.join(',')}`)
            .then(result => {
                const { campaigns } = this.data = result.data
                this.campaigns = campaigns

                this.countCampaignItemsInWeek()

                this.$timeout(() => {
                    this.loaded = true
                })
            })
    }

    countCampaignItemsInWeek () {
        this.$scope.$applyAsync(() => {
            this.mapCampaigns(campaign => {
                campaign.model_type = this.campaign_options[campaign.model_type_id]
                campaign.itemsCountInWeek = 0
            })

            this.mapItems(item => {
                const campaign = this.campaigns.find(campaign => (
                    campaign.id == item.campaign_id
                ))
                item.campaign = campaign
                campaign.itemsCountInWeek++
            })
        })
    }

    mapItems (callback) {
        this.mapBlocks((block, broadcast) => {
            for (const item of block.items) {
                if (callback(item, block, broadcast) === false) {
                    return false
                }
            }
        })
    }

    mapBlocks (callback) {
        this.mapBroadcasts(broadcast => {
            for (const block of broadcast.blocks) {
                if (callback(block, broadcast) === false) {
                    return false
                }
            }
        })
    }

    mapBroadcasts (callback) {
        const days = (this.data || {}).days || {}
        dayLoop: for (const day in days) {
            if (!days.hasOwnProperty(day)) continue
            for (const broadcast of days[day].broadcasts) {
                if (callback(broadcast) === false) {
                    break dayLoop
                }
            }
        }
    }

    mapCampaigns (callback) {
        for (const campaign of this.campaigns) {
            if (callback(campaign) === false) {
                break
            }
        }
    }

    onItemSaved (event, isUpdate, savedItem) {
        this.itemSaved(isUpdate, savedItem)
    }

    itemSaved (isUpdate, savedItem) {
        const {
            campaigns: campaignsData,
            $rootScope,
            $scope,
        } = this

        savedItem.campaign = campaignsData.find(campaign => (
            campaign.id == savedItem.campaign_id
        ))

        let sortBlockId = null

        if (isUpdate) {
            this.mapItems((item, block) => {
                if (savedItem.id == item.id) {
                    if (savedItem.order != item.order) {
                        sortBlockId = block.id
                    }

                    if (item.updated_at <= savedItem.updated_at) {
                        $rootScope.$broadcast('item-planner_item-update_' + item.id, savedItem)
                        Object.assign(item, savedItem)
                    }

                    return false
                }
            })
        } else {
            this.mapBlocks(block => {
                if (savedItem.block_id == block.id) {
                    if (block.items.findIndex(item => item.id == savedItem.id) === -1) {
                        block.items = [...block.items, savedItem]
                        sortBlockId = savedItem.block_id
                    }
                    return false
                }
            })
        }

        if (sortBlockId !== null) {
            $rootScope.$broadcast('item-planner_sort-block_' + sortBlockId)
        }

        $scope.$applyAsync()
    }

    updateCampaignCounter (campaignId, addToCounter) {
        this.mapCampaigns(campaign => {
            if (campaign.id === campaignId) {
                campaign.items_count = campaign.items_count + addToCounter
                this.debounceCountCampaignItemsInWeek()
                return false
            }
        })
    }

    info () {
        this.$mdDialog.show({
            controller: 'itemPlannerInfoDialogCtrl',
            templateUrl: 'itemPlannerInfoDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true,
        })
    }

    startCopy () {
    }

    set inCopyState (itemPlannerInCopyState) {
        this.$rootScope.itemPlannerInCopyState = itemPlannerInCopyState
    }

    get inCopyState () {
        return this.$rootScope.itemPlannerInCopyState
    }

    startCopyPasteAction (copyType = 'copy') {
        const { $scope, selection } = this

        if (selection.getSelectionLength() !== 0) {
            this.inCopyState = true
            $scope.$applyAsync(() => {
                this.itemPlannerCopyAction = copyType
            })

        } else {
            // Give a warning that the user must first select some items
        }
    }

    clearCopyPasteAction () {
        const { $scope, $rootScope, selection } = this

        this.inCopyState = false
        this.itemPlannerCopyAction = null

        $scope.$applyAsync(() => {
            $rootScope.itemPlannerHoverBlock = null
            $rootScope.$broadcast('item-planner_show-broadcast', null)
            selection.clearSelection()
        })
    }

    onWindowKeyDown (event) {

        switch (event.key) {

            case 'Escape':
                this.clearCopyPasteAction()
                break

            case 'x':
                this.startCopyPasteAction('cut')
                break

            case 'c':
                this.startCopyPasteAction()
                break

            case 'v':
                this.pasteItemSelection()
                break

            case 'd':
            case 'Delete':
                this.bulkDeleteItemsSelection()
                break

            // default:
            //     console.log(event.key, event);
            //     break;

        }
    }

    pasteItemSelection () {
        const { $rootScope } = this

        if (!this.allowedToPaste) {
            clearTimeout(this.currentTimeOut)
            return
        }
        if (this.inCopyState) {
            this.allowedToPaste = false
            const blockId = $rootScope.itemPlannerHoverBlock
            const options = {
                placeOnEndOfBlock: true,
            }

            if (this.itemPlannerCopyAction === 'copy') {
                options.copyToNewItem = true
            }

            this.currentTimeOut = setTimeout(() => {
                this.allowedToPaste = true
            }, 1000)

            $rootScope.$broadcast('item-planner_move-item-to-block_' + blockId, options)

            if (this.itemPlannerCopyAction !== 'copy') {
                this.clearCopyPasteAction()
            }
        }
    }

    bulkDeleteItemsSelection () {
        const {
            $rootScope,
            $mdDialog,
            $http,
            selection,
        } = this

        const itemsToDelete = selection.getSelectionItems()
        if (itemsToDelete.length) {

            $mdDialog.show({
                controller: 'ConfirmManyDialogCtrl',
                templateUrl: 'confirmManyDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer .md-dialog-container')),
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    count: {
                        removing: {
                            items: itemsToDelete.length,
                        },
                    },
                    option: null,
                }
            })
                .then(() => {
                    selection.clearSelection()
                    $http.post('items/delete/bulk', _.map(itemsToDelete, 'id'))
                        .then(() => {
                            for (const item of itemsToDelete) {
                                $rootScope.$broadcast('item-planner_remove-item_block_' + item.block_id, item)
                            }
                        })
                })
                .catch(error => {
                    if (error) {
                        console.error(error)
                    } else {
                        selection.clearSelection()
                    }
                })
        }
    }

    editCampaign (campaignId) {
        this.$state.go('item-planner.update', {
            id: campaignId,
        })
    }

    selectedSetCampaign (id) {
        const { $rootScope } = this
        if ($rootScope.selectedCampaign === id) {
            $rootScope.selectedCampaign = null
        } else {
            $rootScope.selectedCampaign = id
        }
    }

    destroy () {
        window.removeEventListener('keydown', this.onWindowKeyDown)
    }

    destroyCampaign (id, title, event) {
        event.stopPropagation()

        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: 'confirmDialog.ngTemplate',
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: event,
            clickOutsideToClose: true
        }).then(() => {
            this.$http.delete('/item-planner/' + id).then(() => {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.delete?object=campaign&title=' + title, //@trans('labels.campaign')
                    hideDelay: 6000,
                    position: ('top right')
                })
                this.fetch(this.date)
            })
        })

    }

    updateFilters () {
        let filters = []
        this.filterMap.map((filter) => {
            if (!filter.enabled) {
                filters.push(filter.id)
            }
        })
        this.$http.post('/userfilters/campaign', {
            campaign_filter: filters
        }).then(() => {
            this.fetch(this.date, true)
        })
    }
}

ItemPlannerOverviewCtrl.$inject = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    '$timeout',
    '$mdDialog',
    '$mdToast',
    'filterMap',
    '$location',
    'itemPlannerSelection',
    'wsEvents',
]

module.exports = ItemPlannerOverviewCtrl
